// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/branches.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Export } from "../../artifacts/v1/export_pb";
import { file_chalk_artifacts_v1_export } from "../../artifacts/v1/export_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { Deployment, DeploymentStatus } from "./deployment_pb";
import { file_chalk_server_v1_deployment } from "./deployment_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/branches.proto.
 */
export const file_chalk_server_v1_branches: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_export, file_chalk_auth_v1_permissions, file_chalk_server_v1_deployment, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.Branch
 */
export type Branch = Message<"chalk.server.v1.Branch"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int32 deployment_count = 4;
   */
  deploymentCount: number;
};

/**
 * Describes the message chalk.server.v1.Branch.
 * Use `create(BranchSchema)` to create a new message.
 */
export const BranchSchema: GenMessage<Branch> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 0);

/**
 * @generated from message chalk.server.v1.PythonPackage
 */
export type PythonPackage = Message<"chalk.server.v1.PythonPackage"> & {
  /**
   * @generated from field: string package_name = 1;
   */
  packageName: string;

  /**
   * @generated from field: string package_version = 2;
   */
  packageVersion: string;
};

/**
 * Describes the message chalk.server.v1.PythonPackage.
 * Use `create(PythonPackageSchema)` to create a new message.
 */
export const PythonPackageSchema: GenMessage<PythonPackage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 1);

/**
 * @generated from message chalk.server.v1.VenvPackages
 */
export type VenvPackages = Message<"chalk.server.v1.VenvPackages"> & {
  /**
   * @generated from field: repeated chalk.server.v1.PythonPackage venv_packages = 1;
   */
  venvPackages: PythonPackage[];
};

/**
 * Describes the message chalk.server.v1.VenvPackages.
 * Use `create(VenvPackagesSchema)` to create a new message.
 */
export const VenvPackagesSchema: GenMessage<VenvPackages> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 2);

/**
 * @generated from message chalk.server.v1.BranchWithLatestDeployment
 */
export type BranchWithLatestDeployment = Message<"chalk.server.v1.BranchWithLatestDeployment"> & {
  /**
   * @generated from field: chalk.server.v1.Branch branch = 1;
   */
  branch?: Branch;

  /**
   * @generated from field: chalk.server.v1.DeploymentStatus latest_deployment_status = 2;
   */
  latestDeploymentStatus: DeploymentStatus;

  /**
   * @generated from field: google.protobuf.Timestamp latest_deployment_created = 3;
   */
  latestDeploymentCreated?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp latest_deployment_updated = 4;
   */
  latestDeploymentUpdated?: Timestamp;

  /**
   * @generated from field: optional string latest_deployment_id = 5;
   */
  latestDeploymentId?: string;

  /**
   * User id that triggered the branch's latest deployment (the deployment's
   * `triggered_by`); unset for system-triggered or pre-tracking deployments.
   *
   * @generated from field: optional string latest_deployment_triggered_by = 6;
   */
  latestDeploymentTriggeredBy?: string;
};

/**
 * Describes the message chalk.server.v1.BranchWithLatestDeployment.
 * Use `create(BranchWithLatestDeploymentSchema)` to create a new message.
 */
export const BranchWithLatestDeploymentSchema: GenMessage<BranchWithLatestDeployment> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 3);

/**
 * @generated from message chalk.server.v1.GetBranchWithLatestDeploymentRequest
 */
export type GetBranchWithLatestDeploymentRequest = Message<"chalk.server.v1.GetBranchWithLatestDeploymentRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.server.v1.GetBranchWithLatestDeploymentRequest.
 * Use `create(GetBranchWithLatestDeploymentRequestSchema)` to create a new message.
 */
export const GetBranchWithLatestDeploymentRequestSchema: GenMessage<GetBranchWithLatestDeploymentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 4);

/**
 * @generated from message chalk.server.v1.GetBranchWithLatestDeploymentResponse
 */
export type GetBranchWithLatestDeploymentResponse = Message<"chalk.server.v1.GetBranchWithLatestDeploymentResponse"> & {
  /**
   * @generated from field: chalk.server.v1.BranchWithLatestDeployment branch_with_latest_deployment = 1;
   */
  branchWithLatestDeployment?: BranchWithLatestDeployment;
};

/**
 * Describes the message chalk.server.v1.GetBranchWithLatestDeploymentResponse.
 * Use `create(GetBranchWithLatestDeploymentResponseSchema)` to create a new message.
 */
export const GetBranchWithLatestDeploymentResponseSchema: GenMessage<GetBranchWithLatestDeploymentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 5);

/**
 * @generated from message chalk.server.v1.DeleteBranchRequest
 */
export type DeleteBranchRequest = Message<"chalk.server.v1.DeleteBranchRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.server.v1.DeleteBranchRequest.
 * Use `create(DeleteBranchRequestSchema)` to create a new message.
 */
export const DeleteBranchRequestSchema: GenMessage<DeleteBranchRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 6);

/**
 * @generated from message chalk.server.v1.DeleteBranchResponse
 */
export type DeleteBranchResponse = Message<"chalk.server.v1.DeleteBranchResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteBranchResponse.
 * Use `create(DeleteBranchResponseSchema)` to create a new message.
 */
export const DeleteBranchResponseSchema: GenMessage<DeleteBranchResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 7);

/**
 * @generated from message chalk.server.v1.ListBranchWithLatestDeploymentsFilters
 */
export type ListBranchWithLatestDeploymentsFilters = Message<"chalk.server.v1.ListBranchWithLatestDeploymentsFilters"> & {
  /**
   * Case-insensitive literal substring search. Currently searches branch names.
   *
   * @generated from field: optional string search_string = 1;
   */
  searchString?: string;

  /**
   * Filter to branches whose latest deployment has one of these statuses.
   *
   * @generated from field: repeated chalk.server.v1.DeploymentStatus statuses = 2;
   */
  statuses: DeploymentStatus[];

  /**
   * Filter to branches whose latest deployment was triggered by one of these agent ids.
   *
   * @generated from field: repeated string deployed_by = 3;
   */
  deployedBy: string[];
};

/**
 * Describes the message chalk.server.v1.ListBranchWithLatestDeploymentsFilters.
 * Use `create(ListBranchWithLatestDeploymentsFiltersSchema)` to create a new message.
 */
export const ListBranchWithLatestDeploymentsFiltersSchema: GenMessage<ListBranchWithLatestDeploymentsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 8);

/**
 * @generated from message chalk.server.v1.ListBranchWithLatestDeploymentsRequest
 */
export type ListBranchWithLatestDeploymentsRequest = Message<"chalk.server.v1.ListBranchWithLatestDeploymentsRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Filter to branches whose latest deployment has one of these statuses.
   * Empty = no status filter.
   *
   * @generated from field: repeated chalk.server.v1.DeploymentStatus status = 3 [deprecated = true];
   * @deprecated
   */
  status: DeploymentStatus[];

  /**
   * Filter to branches whose latest deployment was triggered by one of these
   * agent ids. Empty = no deployed-by filter.
   *
   * @generated from field: repeated string deployed_by = 4 [deprecated = true];
   * @deprecated
   */
  deployedBy: string[];

  /**
   * Sort direction on the branch's last-activity timestamp (updated_at, the
   * keyset-pagination key). false/unset = descending (default); true = ascending.
   *
   * @generated from field: optional bool sort_ascending = 5;
   */
  sortAscending?: boolean;

  /**
   * @generated from field: optional chalk.server.v1.ListBranchWithLatestDeploymentsFilters filters = 6;
   */
  filters?: ListBranchWithLatestDeploymentsFilters;
};

/**
 * Describes the message chalk.server.v1.ListBranchWithLatestDeploymentsRequest.
 * Use `create(ListBranchWithLatestDeploymentsRequestSchema)` to create a new message.
 */
export const ListBranchWithLatestDeploymentsRequestSchema: GenMessage<ListBranchWithLatestDeploymentsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 9);

/**
 * @generated from message chalk.server.v1.ListBranchWithLatestDeploymentsResponse
 */
export type ListBranchWithLatestDeploymentsResponse = Message<"chalk.server.v1.ListBranchWithLatestDeploymentsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.BranchWithLatestDeployment branch_with_latest_deployments = 1;
   */
  branchWithLatestDeployments: BranchWithLatestDeployment[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListBranchWithLatestDeploymentsResponse.
 * Use `create(ListBranchWithLatestDeploymentsResponseSchema)` to create a new message.
 */
export const ListBranchWithLatestDeploymentsResponseSchema: GenMessage<ListBranchWithLatestDeploymentsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 10);

/**
 * @generated from message chalk.server.v1.GetBranchVenvInstalledPackagesRequest
 */
export type GetBranchVenvInstalledPackagesRequest = Message<"chalk.server.v1.GetBranchVenvInstalledPackagesRequest"> & {
  /**
   * @generated from field: string branch_id = 1;
   */
  branchId: string;

  /**
   * @generated from field: string latest_deployment_id = 2;
   */
  latestDeploymentId: string;
};

/**
 * Describes the message chalk.server.v1.GetBranchVenvInstalledPackagesRequest.
 * Use `create(GetBranchVenvInstalledPackagesRequestSchema)` to create a new message.
 */
export const GetBranchVenvInstalledPackagesRequestSchema: GenMessage<GetBranchVenvInstalledPackagesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 11);

/**
 * @generated from message chalk.server.v1.GetBranchVenvInstalledPackagesResponse
 */
export type GetBranchVenvInstalledPackagesResponse = Message<"chalk.server.v1.GetBranchVenvInstalledPackagesResponse"> & {
  /**
   * @generated from field: map<string, chalk.server.v1.VenvPackages> venv_packages_by_name = 1;
   */
  venvPackagesByName: { [key: string]: VenvPackages };
};

/**
 * Describes the message chalk.server.v1.GetBranchVenvInstalledPackagesResponse.
 * Use `create(GetBranchVenvInstalledPackagesResponseSchema)` to create a new message.
 */
export const GetBranchVenvInstalledPackagesResponseSchema: GenMessage<GetBranchVenvInstalledPackagesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 12);

/**
 * @generated from message chalk.server.v1.StartBranchDeploymentRequest
 */
export type StartBranchDeploymentRequest = Message<"chalk.server.v1.StartBranchDeploymentRequest"> & {
  /**
   * @generated from field: string branch_name = 1;
   */
  branchName: string;

  /**
   * @generated from field: bytes archive = 2;
   */
  archive: Uint8Array;
};

/**
 * Describes the message chalk.server.v1.StartBranchDeploymentRequest.
 * Use `create(StartBranchDeploymentRequestSchema)` to create a new message.
 */
export const StartBranchDeploymentRequestSchema: GenMessage<StartBranchDeploymentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 13);

/**
 * @generated from message chalk.server.v1.StartBranchDeploymentResponse
 */
export type StartBranchDeploymentResponse = Message<"chalk.server.v1.StartBranchDeploymentResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Deployment deployment = 1;
   */
  deployment?: Deployment;

  /**
   * @generated from field: repeated string deployment_warnings = 2;
   */
  deploymentWarnings: string[];
};

/**
 * Describes the message chalk.server.v1.StartBranchDeploymentResponse.
 * Use `create(StartBranchDeploymentResponseSchema)` to create a new message.
 */
export const StartBranchDeploymentResponseSchema: GenMessage<StartBranchDeploymentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 14);

/**
 * @generated from message chalk.server.v1.GetBranchDeploymentStateRequest
 */
export type GetBranchDeploymentStateRequest = Message<"chalk.server.v1.GetBranchDeploymentStateRequest"> & {
  /**
   * @generated from field: string branch_name = 1;
   */
  branchName: string;

  /**
   * @generated from field: string deployment_id = 2;
   */
  deploymentId: string;
};

/**
 * Describes the message chalk.server.v1.GetBranchDeploymentStateRequest.
 * Use `create(GetBranchDeploymentStateRequestSchema)` to create a new message.
 */
export const GetBranchDeploymentStateRequestSchema: GenMessage<GetBranchDeploymentStateRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 15);

/**
 * @generated from message chalk.server.v1.GetBranchDeploymentStateResponse
 */
export type GetBranchDeploymentStateResponse = Message<"chalk.server.v1.GetBranchDeploymentStateResponse"> & {
  /**
   * @generated from field: chalk.server.v1.Deployment deployment = 1;
   */
  deployment?: Deployment;

  /**
   * @generated from field: optional chalk.artifacts.v1.Export export = 2;
   */
  export?: Export;

  /**
   * @generated from field: optional string deployment_stage = 3;
   */
  deploymentStage?: string;
};

/**
 * Describes the message chalk.server.v1.GetBranchDeploymentStateResponse.
 * Use `create(GetBranchDeploymentStateResponseSchema)` to create a new message.
 */
export const GetBranchDeploymentStateResponseSchema: GenMessage<GetBranchDeploymentStateResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_branches, 16);

/**
 * @generated from service chalk.server.v1.BranchService
 */
export const BranchService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.BranchService.StartBranchDeployment
   */
  startBranchDeployment: {
    methodKind: "unary";
    input: typeof StartBranchDeploymentRequestSchema;
    output: typeof StartBranchDeploymentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.BranchService.GetBranchDeploymentState
   */
  getBranchDeploymentState: {
    methodKind: "unary";
    input: typeof GetBranchDeploymentStateRequestSchema;
    output: typeof GetBranchDeploymentStateResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.BranchService.GetBranchWithLatestDeployment
   */
  getBranchWithLatestDeployment: {
    methodKind: "unary";
    input: typeof GetBranchWithLatestDeploymentRequestSchema;
    output: typeof GetBranchWithLatestDeploymentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.BranchService.DeleteBranch
   */
  deleteBranch: {
    methodKind: "unary";
    input: typeof DeleteBranchRequestSchema;
    output: typeof DeleteBranchResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.BranchService.ListBranchWithLatestDeployments
   */
  listBranchWithLatestDeployments: {
    methodKind: "unary";
    input: typeof ListBranchWithLatestDeploymentsRequestSchema;
    output: typeof ListBranchWithLatestDeploymentsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.BranchService.GetBranchVenvInstalledPackages
   */
  getBranchVenvInstalledPackages: {
    methodKind: "unary";
    input: typeof GetBranchVenvInstalledPackagesRequestSchema;
    output: typeof GetBranchVenvInstalledPackagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_branches, 0);

